module.exports = __webpack_public_path__ + "static/media/Emmalee Barnett's Resume.doc.f75bf99f.pdf";